module.exports = __webpack_public_path__ + "img/i-communnity-mono.a2ae7a85.svg";